module.exports = __webpack_public_path__ + "static/media/no-photo.02589509.svg";